<template>
    <div class="w-full flex flex-col">
        <div class="flex-grow shadow-lg border bg-white hover:bg-secondary rounded-2xl p-8 flex flex-col group relative hoverable">
            <p class="group-hover:text-white text-ternary leading-tight font-semibold text-xl h-8 bg-gray-300 animate-pulse"></p>
            <div class="mt-16 flex justify-end flex-auto flex-col items-end">
                <div class="border-2 font-medium border-ternary text-white hover:text-ternary bg-ternary hover:bg-white rounded-lg px-5 py-2 text-sm cursor-pointer animate-pulse">Start Service</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "service-tile-shimmer",
    props: ["item"],
}
</script>